import './styles.css'
import { createRouter } from './router.js'
import { renderHome, bindHome } from './pages/home.js'
import { renderLookup, bindLookup } from './pages/lookup.js'
import { renderTicket, bindTicket } from './pages/ticket.js'
const app = document.getElementById('app')

function legacyRedirect() {
  return `<div class="wrap"><p class="muted">Redirigiendo…</p></div>`
}

const routes = [
  { path: '/', title: 'Incidencias huésped', render: () => renderHome() },
  { path: '/consultar', title: 'Consultar ticket', render: () => renderLookup() },
  { path: '/t/:token', title: 'Tu ticket', render: () => renderTicket({ loading: true }) },
  { path: '/s/:tenant', title: 'Incidencias', render: legacyRedirect, legacy: true },
  { path: '/s/:tenant/login', title: 'Incidencias', render: legacyRedirect, legacy: true },
  { path: '/s/:tenant/tickets', title: 'Incidencias', render: legacyRedirect, legacy: true },
  { path: '/s/:tenant/tickets/new', title: 'Incidencias', render: legacyRedirect, legacy: true },
  { path: '/s/:tenant/auth/verify/:token', title: 'Incidencias', render: legacyRedirect, legacy: true },
]

const router = createRouter(routes, {
  async onResolve({ route, params }) {
    if (route.legacy) {
      return router.navigate('/', { replace: true })
    }

    document.title = route.title || 'Incidencias huésped'

    if (route.path === '/t/:token') {
      app.innerHTML = renderTicket({ loading: true })
      const result = await bindTicket({ token: params.token })
      app.innerHTML = renderTicket({
        loading: false,
        ticket: result.ticket,
        error: result.error,
      })
      return
    }

    app.innerHTML = route.render({ params })
    if (route.path === '/') bindHome({ navigate: router.navigate })
    if (route.path === '/consultar') bindLookup({ navigate: router.navigate })
  },
})

router.resolve()
